import { Grid, IconButton, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Typography, tableCellClasses } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Button, Menu, TableContainer } from "@mui/material"
import { fetchReport, downloadGstrReport, downloadGstrExcelReport } from '../../store/reportStore/reportThunk';
import { useReportShare } from './useReportShare';
import { clearReportsData } from '../../store/reportStore/reportslice';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import styled_ from "@emotion/styled";
import LoadingButton from '@mui/lab/LoadingButton';
import { ApiStatus } from "../../utils/api.types";
import { Utils, VocuherCategory } from "../../utils/common-utils";
import Filters from '../Filters/Filters';
import DownloadIcon from "@mui/icons-material/Download"
import PrintIcon from "@mui/icons-material/Print"
import ReusableReportHeader from './ReusableReportHeader';
import { toast } from 'react-toastify';

const StyledTableCell = styled_(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#eaecf0',
    color: '#000',
    // borderTop: '0.75px solid #d9d4d4',
    // borderBottom: '0.75px solid #d9d4d4',
    border: '0.75px solid #d9d4d4',
    // border: '1px solid red',
    margin: 0,
    padding: 5,
    fontSize: '9pt',
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    // border: '1px solid red',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: '9pt',
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    // border:'none',
    border: '0.75px solid #d9d4d4',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled_(TableRow)(({ theme }) => ({
  // '&:nth-of-type(even)': {
  //   backgroundColor: '#fbfbfb',
  //   // border: '0.5px dashed #9da7b7',
  // },
  // '&:nth-of-type(odd)': {
  //   backgroundColor: '#e9ecf1',
  //   // border: '0.5px dashed #9da7b7',
  // },
  // // hide last border
  // '&:last-child td, &:last-child th': {
  // },
}));


interface ReportDataProps {
  type: string;
}
const ReportData: FC<ReportDataProps> = (props) => {
  const dispatch = useAppDispatch();
  const { reportsData, status } = useAppSelector(state => state.reports);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const [filters, setFilters] = useState('');
  const [downloadAnchorEl, setDownloadAnchorEl] = useState<null | HTMLElement>(null)
  const downloadMenuOpen = Boolean(downloadAnchorEl)
  const [selectedDownloadOption, setSelectedDownloadOption] = useState('JSON Download')

  // sample test data for row spanning
  const orderData = [
    {
      id: 1,
      customerName: 'John Doe',
      items: [
        { name: 'Apple' },
        { name: 'Banana' },
        { name: 'Orange' }
      ]
    },
    {
      id: 2,
      customerName: 'Jane Smith',
      items: [
        { name: 'Grapes' },
        { name: 'Pineapple' }
      ]
    },
    {
      id: 3,
      customerName: 'Purushottam Bitle',
      items: [
        { name: '' },
      ]
    },
    {
      id: 4,
      customerName: 'Purushottam eer',
      items: [
        { name: 'dd' },
        { name: 'Pineapple' }
      ]
    },
    {
      id: 5,
      customerName: 'Purushottam eer',
      items: [
        { name: 'dd' },
        { name: 'Pineapple' },
        { name: 'dd' },
        { name: 'Pineapple' }
      ]
    },
    // Add more orders here
  ];


  const filterOnChangeHandler = (data: any) => {
    setFilters(data);
  };

  useEffect(() => {
    // Clear previous data when component mounts or type changes
    dispatch(clearReportsData());
    
    const { _id: id } = selectedAccount;
    console.log("props.type === ", props.type);
    const _filters = filters || undefined
    if (_filters) {
      console.log("I got the filters === ");
      dispatch(fetchReport({ accountId: id, type: props.type, isShareExcel: "false", params: _filters }));
    } else {
      console.log("calling without filters === ");
      dispatch(fetchReport({ accountId: id, type: props.type, isShareExcel: "false" }));
    }

  }, [dispatch, selectedAccount, filters, props.type])

  // Clear data when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearReportsData());
    };
  }, [])

  // Share-by-email via the shared hook (account email + configured recipients, gated by the master toggle).
  const { handleShare: handleShareReportToEmail, shareTooltip } = useReportShare(
    `sale-report?voucherCategory=${props.type}`,
    () => filters
  );
  const handlePrint = () => {
    window.print()
  }

  const handleDownloadClick = (event: React.MouseEvent<HTMLElement>) => {
    setDownloadAnchorEl(event.currentTarget)
  }

  const handleDownloadClose = () => {
    setDownloadAnchorEl(null)
  }

  const handleDownloadJSON = () => {
    const jsonData = JSON.stringify(reportsData, null, 2)
    const blob = new Blob([jsonData], { type: "application/json" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = `gst-report-${props.type}-${new Date().toISOString().split("T")[0]}.json`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    handleDownloadClose()
  }

  const handleDownloadExcel = async () => {
    const { _id: id } = selectedAccount;
    if (!filters) {
      toast.error("Please select date range to download Excel");
      handleDownloadClose();
      return;
    }

    dispatch(downloadGstrExcelReport({
      accountId: id,
      type: props.type,
      isDownloadExcel: "true",
      params: filters
    })).unwrap().then((data) => {
      if (data) {
        // Create a Blob from the response data
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);

        console.log(url);

        // Create a link element, set the href, and trigger the download
        const a = document.createElement("a");
        a.href = url;
        const reportName = props.type === 'sales' ? 'GSTR1_Sales_Summary' : 'GSTR2_Purchase_Summary';
        const timestamp = new Date().toISOString().split('T')[0];
        a.download = `${reportName}_${timestamp}.xlsx`;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        toast.success("Excel download completed");
      }
    }).catch((error: any) => {
      toast.error(error.message || "Failed to download Excel");
      console.error("Error downloading Excel:", error);
    });

    handleDownloadClose()
  }

  const handleDownloadPDF = async () => {
    const { _id: id } = selectedAccount;
    if (!filters) {
      toast.error("Please select date range to download PDF");
      handleDownloadClose();
      return;
    }

    dispatch(downloadGstrReport({
      accountId: id,
      type: props.type,
      isDownloadPdf: "true",
      params: filters
    })).unwrap().then((data) => {
      if (data) {
        // Create a Blob from the response data
        const blob = new Blob([data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        console.log(url);

        // Create a link element, set the href, and trigger the download
        const a = document.createElement("a");
        a.href = url;
        const reportName = props.type === 'sales' ? 'gstr1_sales_summary' : 'gstr2_purchase_summary';
        a.download = `${reportName}.pdf`;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        toast.success("Download completed");
      }
    }).catch((error: any) => {
      toast.error(error.message || "Failed to download PDF");
      console.error("Error downloading PDF:", error);
    });

    handleDownloadClose()
  }

  return (
    <>
      {/* <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={0}>
        <Grid item xs={8}>
          <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
            <Grid container>
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>
                  
                </div>
                <IconButton
                  style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                  size='small' >
                  <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                </IconButton>
                <h3 style={{ marginTop: -1, fontWeight: 600 }}>{props.type == VocuherCategory.PURCHASE ? 'GST Purchase Report' : 'GST Sale Report'}</h3>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid> */}
      <Grid container spacing={2} p={0.5} mb={1}>
        {/* Need this container to keep show filter on screen */}
      </Grid>
      {/* Reusable Report Header */}
      

      <Grid container spacing={2} >
        <Grid item xs={12}>
          <Box sx={{width: 'calc(100% - 7px)', overflow: 'hidden',mb:2 }} className={'c-card2'}>

            <ReusableReportHeader
              reportType={props.type}
              recordCount={reportsData ? reportsData.length : 0}
              isLoading={status === ApiStatus.LOADING}
              onDownloadPDF={handleDownloadPDF}
              onDownloadExcel={handleDownloadExcel}
              onDownloadJSON={handleDownloadJSON}
              // onPrint={handlePrint}
              onShare={handleShareReportToEmail}
              shareTooltip={shareTooltip}
            />


            <Grid container p={2} style={{ borderBottom: '.5px solid #9da7b7' }}>
              <Grid xs={10} >
                <Filters type={props.type} filterHandler={filterOnChangeHandler} hideFilter={true} />
              </Grid>
              <Grid xs={2} >
                {/* "Send To Account Email" button kept for reference but disabled — sharing is now
                    done via the Share icon next to Export (top-right), which emails the configured
                    recipients plus the account email. */}
                {/* <LoadingButton
                  className={'buttonContainedRoot'}
                  size='small'
                  type="button"
                  name={'submit'}
                  onClick={() => handleShareReportToEmail()}
                  loading={status === ApiStatus.LOADING}
                  variant="contained"
                  sx={{ minWidth: 160 }}
                >
                  Send To Account Email
                </LoadingButton> */}
              </Grid>
            </Grid>
            <div style={{ marginBottom: 12 }}>
              <Table stickyHeader sx={{ minWidth: 700, marginBottom: '100px' }} size='small' aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell width={90}>Date</StyledTableCell>
                    <StyledTableCell>Type</StyledTableCell>
                    <StyledTableCell>GSTIN</StyledTableCell>
                    <StyledTableCell width={100}># No</StyledTableCell>
                    <StyledTableCell width={120}>State</StyledTableCell>
                    <StyledTableCell width={150}>Customer</StyledTableCell>
                    <StyledTableCell>HSN/SAC</StyledTableCell>
                    <StyledTableCell>Amount</StyledTableCell>
                    <StyledTableCell>IGST</StyledTableCell>
                    <StyledTableCell>CGST</StyledTableCell>
                    <StyledTableCell>SGST</StyledTableCell>
                    <StyledTableCell>TaxAmount</StyledTableCell>
                    <StyledTableCell>TAX %</StyledTableCell>
                    <StyledTableCell>TOTAL</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(reportsData && reportsData.length > 0) ? reportsData.map((e: any, index) =>
                    <>
                      <StyledTableRow key={index}>
                        <StyledTableCell rowSpan={e.groupData.length || 0}>{e.voucherDate}</StyledTableCell>
                        <StyledTableCell rowSpan={e.groupData.length || 0}>{e.voucherType}</StyledTableCell>
                        <StyledTableCell rowSpan={e.groupData.length || 0}>{e.gstin}</StyledTableCell>
                        <StyledTableCell rowSpan={e.groupData.length || 0}>{e.invoiceNumber}</StyledTableCell>
                        <StyledTableCell rowSpan={e.groupData.length || 0}>{e.placeOfSupply}</StyledTableCell>
                        <StyledTableCell rowSpan={e.groupData.length || 0}>{e.clientName}</StyledTableCell>
                        {e.groupData.length > 0 ?
                          <>
                            <StyledTableCell>
                              {e.groupData.length > 0 ? e.groupData[0].hsnOrSacCode != '' ? e.groupData[0].hsnOrSacCode : '-' : '-'}
                            </StyledTableCell>
                            <StyledTableCell>{Utils.formatNumber(e.groupData[0].amount, false, true)}</StyledTableCell>
                            <StyledTableCell>{Utils.formatNumber(e.groupData[0].igstamount, false, true)}</StyledTableCell>
                            <StyledTableCell>{Utils.formatNumber(e.groupData[0].cgstamount, false, true)}</StyledTableCell>
                            <StyledTableCell>{Utils.formatNumber(e.groupData[0].sgstamount, false, true)}</StyledTableCell>
                            <StyledTableCell>{e.groupData[0].taxPercent}</StyledTableCell>
                            <StyledTableCell>{Utils.formatNumber(e.groupData[0].totalTaxAmount, false, true)}</StyledTableCell>
                            <StyledTableCell>{Utils.formatNumber(e.groupData[0].finalAmount, false, true)}</StyledTableCell>
                          </>
                          :
                          <>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                            <StyledTableCell>{''}</StyledTableCell>
                          </>
                        }

                      </StyledTableRow>
                      {e.groupData.slice(1).map((item: any, index: any) => (
                        <StyledTableRow key={index + 1}>
                          <StyledTableCell>{item.hsnOrSacCode != '' ? item.hsnOrSacCode : '-'}</StyledTableCell>
                          <StyledTableCell>{Utils.formatNumber(item.amount, false, true)}</StyledTableCell>
                          <StyledTableCell>{Utils.formatNumber(item.igstamount, false, true)}</StyledTableCell>
                          <StyledTableCell>{Utils.formatNumber(item.cgstamount, false, true)}</StyledTableCell>
                          <StyledTableCell>{Utils.formatNumber(item.sgstamount, false, true)}</StyledTableCell>
                          <StyledTableCell>{item.taxPercent}</StyledTableCell>
                          <StyledTableCell>{Utils.formatNumber(item.totalTaxAmount, false, true)}</StyledTableCell>
                          <StyledTableCell>{Utils.formatNumber(item.finalAmount, false, true)}</StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </>
                  ) :
                    ''
                  }
                </TableBody>
              </Table>
            </div>
          </Box>

        </Grid>
      </Grid>
    </>
  );
}
export default ReportData;